import React from "react";
import { ShieldCheck, Zap, Globe, Lock, Server, Activity } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const benefits = [{
  title: "Anxiety-Free Experience",
  description: "Our gentle sedation options allow you to relax completely, turning dental anxiety into a peaceful, stress-free path to a healthier smile.",
  icon: Lock
}, {
  title: "Multiple Procedures in One Visit",
  description: "Maximize your time by combining several treatments into a single appointment, allowing us to restore your smile efficiently and comfortably.",
  icon: Zap
}, {
  title: "Compassionate Clinical Care",
  description: "We blend high-end medical precision with the warmth of El Monte hospitality, ensuring every patient feels valued and cared for.",
  icon: Activity
}, {
  title: "Advanced Safety Monitoring",
  description: "Your well-being is our priority. Our clinical team uses state-of-the-art monitoring systems to ensure total safety during every procedure.",
  icon: Server
}, {
  title: "Efficient Recovery Process",
  description: "Sedation minimizes the body's stress response, often resulting in a more comfortable post-operative period and a faster return to daily life.",
  icon: ShieldCheck
}, {
  title: "Affordable Quality Service",
  description: "We believe everyone deserves a beautiful smile. Our sedation services are priced to be accessible without compromising on professional standards.",
  icon: Globe
}];
export default function KeyBenefits() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section data-section-id="18687" id="benefits-of-sedation" ref={ref} className="relative w-full py-24 overflow-hidden bg-background">
      {}
      <div className="absolute top-0 left-1/2 -translate-x-1/2 w-full h-full max-w-7xl pointer-events-none">
        <div className="absolute top-20 left-20 w-96 h-96 bg-primary/5 rounded-full blur-3xl" />
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-secondary/20 rounded-full blur-3xl" />
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-[55px]">
          {benefits.map((benefit, i) => <div key={i} data-index={i} className={`transition-all duration-700 ease-out ${isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10"}`} style={{
          transitionDelay: `${i * 100}ms`
        }}>
              <Card className="h-full bg-card backdrop-blur-none border border-border hover:border-primary/30 transition-all duration-300 hover:scale-[1.02] shadow-md hover:shadow-lg group rounded-2xl">
                <CardHeader className="pb-4">
                  <div className="mb-6 inline-flex items-center justify-center w-14 h-14 rounded-full bg-secondary text-primary group-hover:bg-primary group-hover:text-primary-foreground transition-colors duration-300">
                    <benefit.icon className="w-7 h-7 stroke-[2px]" />
                  </div>
                  <CardTitle className="text-2xl font-semibold font-serif tracking-tight text-foreground">
                    {benefit.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-base leading-relaxed text-muted-foreground font-sans">
                    {benefit.description}
                  </CardDescription>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}